module.exports = __webpack_public_path__ + "static/media/mute.943ad063.svg";